<template>
  <v-dialog content-class="password-dialog" max-width="570" v-model="dialog" @input="beforeClose">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mt-2 button-height"
        width="156"
        :color="getAssets.colors.form.buttonBackground"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        alterar senha
      </v-btn>
    </template>
    <v-card v-if="step === 1">
      <v-card-text class="py-0 pt-5">
        <p class="title mt-3" :style="{ color: getAssets.colors.form.buttonBackground }">Alterar senha</p>
        <p class="subtitle mb-6">Primeiro confirme que é você mesmo. Digite sua senha atual:</p>
        <v-text-field
          outlined
          :type="showPassword ? 'text' : 'password'"
          label="Senha"
          v-model="password"
          :error-messages="errorPassword"
          @input="errorPassword = ''"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        />
      </v-card-text>
      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn :color="getAssets.colors.form.buttonBackground" width="110" class="button-height" text @click="dialog = false">cancelar</v-btn>
        <v-btn @click="validatePassword" width="110" class="button-height btn-action" :color="getAssets.colors.form.buttonBackground" :style="{ color: getAssets.colors.form.buttonFont }" :loading="stepOneLoading">próximo</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-text class="py-0 pt-5">
        <p class="title mt-3" :style="{ color: getAssets.colors.form.buttonBackground }">Alterar senha</p>
        <p class="subtitle mb-6">Agora basta digitar e confirmar sua senha. Ela deve ter no mínimo 6 caracteres, ok?</p>
        <v-text-field
          outlined
          :type="showNewPassword ? 'text' : 'password'"
          label="Nova senha"
          v-model="newPassword"
          :error-messages="errorNewPassword"
          @input="errorNewPassword = ''"
          :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showNewPassword = !showNewPassword"
        />
        <v-text-field
          outlined
          class="mt-2"
          :type="showConfirmPassword ? 'text' : 'password'"
          label="Confirme sua nova senha"
          v-model="confirmPassword"
          :error-messages="errorConfirmPassword"
          @input="errorConfirmPassword = ''"
          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showConfirmPassword = !showConfirmPassword"
        />
      </v-card-text>
      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn :color="getAssets.colors.form.buttonBackground" width="110" class="button-height" text @click="dialog = false">cancelar</v-btn>
        <v-btn @click="submit" width="110" class="button-height" :color="getAssets.colors.form.buttonBackground" :style="{ color: getAssets.colors.form.buttonFont }" :loading="submitLoading">concluir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ResetPassword',
  data: () => ({
    dialog: false,
    showPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
    password: '',
    newPassword: '',
    confirmPassword: '',
    errorPassword: '',
    errorNewPassword: '',
    errorConfirmPassword: '',
    stepOneLoading: false,
    submitLoading: false,
    step: 1
  }),
  computed: {
    cpfCnpj() {
      return this.$store.getters.USER_INFO.document_no
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    }
  },
  methods: {
    beforeClose() {
      this.step = 1
      this.password = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.errorPassword = ''
      this.errorNewPassword = ''
      this.errorConfirmPassword = ''
    },
    validatePassword() {
      if (!this.password) {
        this.errorPassword = 'Esse campo é obrigatório.'
        return
      }
      this.stepOneLoading = true
      this.$store.dispatch('validatePassword', {
        document_no: this.cpfCnpj,
        password: this.password
      }).then(() => {
        this.step = 2
      }).catch(() => {
        this.errorPassword = 'Senha incorreta'
      }).finally(() => {
        this.stepOneLoading = false
      })
    },
    validate(password) {
      const response = {
        valid: true,
        msg: ''
      }

      if (!password) {
        response.valid = false
        response.msg = 'Esse campo é obrigatório.'
        return response
      }

      if (password.length < 6) {
        response.valid = false
        response.msg = 'Esse campo precisa ter pelo menos 6 caracteres.'
        return response
      }

      return response
    },
    submit() {
      const validatePassword = this.validate(this.newPassword)
      const validateConfirm = this.validate(this.confirmPassword)

      if (!validatePassword.valid || !validateConfirm.valid) {
        this.errorNewPassword = validatePassword.msg
        this.errorConfirmPassword = validateConfirm.msg
        return
      }

      if (this.newPassword !== this.confirmPassword) {
        this.errorNewPassword = 'As senhas não são iguais.'
        this.errorConfirmPassword = 'As senhas não são iguais.'
        return
      }

      this.submitLoading = true
      this.$store.dispatch('updatePassword', {
        password: this.newPassword
      }).then(() => {
        this.dialog = false
        this.$emit('updated')
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
.password-dialog {
  .title {
    font-size: 32px;
    text-align: center;
    margin-bottom: 0px !important;
  }
  .subtitle {
    font-size: 14px;
    color: #6B7580;
    max-width: 400px;
    margin: auto;
    text-align: center;
    line-height: 120%;
    letter-spacing: 0.02em;
  }
  .v-input__slot {
    margin-bottom: 0px !important;
  }
}
</style>
